module.exports = __webpack_public_path__ + "media/icons/career-81608504.png";